export var TransactionSource;
(function (TransactionSource) {
    TransactionSource["CreditCard"] = "CREDIT_CARD";
    TransactionSource["QrSlip"] = "QR_SLIP";
    TransactionSource["Manual"] = "MANUAL";
    TransactionSource["BankTransfer"] = "BANK_TRANSFER";
    TransactionSource["RecurringIncome"] = "RECURRING_INCOME";
    TransactionSource["EmailImport"] = "EMAIL_IMPORT";
})(TransactionSource || (TransactionSource = {}));
//# sourceMappingURL=transaction-source.enum.js.map